<template>
  <div class="row no-gutters body">
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-12 pb-5 mb-4" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background main-card">
          <!-- <div class="row no-gutters">
            <br />
          </div> -->
          <div class="row no-gutters mt-4">
            <div class="col-lg-12 mt-5">
              <!-- <div class="row no-gutters">
                <br />
              </div> -->
              <div class="col-lg-12 mt-5">
                <div class="row no-gutters pointer" @click="previous">                  
                    <img src="../assets/Back.svg" class="img-fluid mr-1" alt="backbtn"/>
                    <label class="ml-2 fontsize12 proximanova-bold black prof-details my-auto pointer">Tracking Details</label>                  
                </div>
              </div>   
              <div class=" card card1 ml-3 mr-3 mt-4 jobSec" v-if="jobNotFound">
                <div class="d-flex flex-column p-5 mx-auto">
                  <img src="../assets/JobNotFound1.png" class="img-fluid col-10 col-md-8 pl-0 pr-0 no-video mx-auto" alt="novideo">
                </div>
              </div>
              <div class="card shadow mr-3 ml-3 mb-3 mt-3" v-if="!jobNotFound">
                <div class="p-2 d-flex">
                    <div class="col-2 mr-2 mr-lg-0 mr-md-0">
                        <div class="backgroundcolor2 p-lg-2 borderradius10 mr-2 mt-4 text-center">
                            <img v-if="selectedtrackJobDetails && selectedtrackJobDetails.companyProfileLink" :src="selectedtrackJobDetails.companyProfileLink" class="prof-img rounded-circle" alt="companylogo">
                            <img v-else src="../assets/Profile_placehlder.svg" class="prof-img rounded-circle" alt="companylogo">
                        </div>
                    </div>
                    <div class="col-10 pl-0 pt-3 pb-3">
                      <div class="d-flex justify-content-between">
                        <div>
                          <span class="fontsize24 black proximanova stylebold mt-lg-2 pointer">{{selectedtrackJobDetails.jobTitle}}</span>
                        </div>
                        <div class="row my-auto">
                          <span class="fontsizemd black stylebold proximanova mr-3 pointer" @click="viewJobDetails()">View Details</span>
                        </div>
                      </div>
                      <div class="d-flex flex-column mt-1">
                        <span class="fontsize16 black proximanova">{{selectedtrackJobDetails.companyName}}</span>
                        <div>
                          <span class="fontsizemd black60 proximanova" v-if="selectedtrackJobDetails.industry">{{selectedtrackJobDetails.industry}}</span>
                          <span class="ml-2 mr-2 black60" v-if="selectedtrackJobDetails.industry && selectedtrackJobDetails.country">|</span>
                          <span class="fontsizemd black60 proximanova">{{selectedtrackJobDetails.country}}</span>
                        </div>
                      </div>
                      <div class="d-flex pt-1">  
                        <div>  
                          <span class="proximanova-semibold fontsize14 black">Applied {{selectedtrackJobDetails.creationD | moment("from", "now", true)}} ago </span>                                              
                          <span class="verticaline ml-2 mr-2"> | </span> 
                          <span class="proximanova fontsize10 black60 pl-1"> {{selectedtrackJobDetails.jobApplicantCount}} Applications </span> 
                        </div>  
                      </div>
                    </div>
                </div>                   
              </div>   
              <div class="card shadow mr-3 ml-3 mb-3 mt-3" v-if="!jobNotFound">
                <div class="p-2 d-flex">
                    <div class="col-12 proximanova">
                      <ul class="StepProgress mt-4" v-if="JobStatistics">
                        <span v-for="(status, index) in JobStatistics" :key="index">
                          <li class="StepProgress-item d-flex"
                            :class="{'is-done' :(status.creationD !== null && JobStatistics[index + 1].creationD !== null), 'is-done1':(status.jobStatus == 'Hired' && status.creationD !== null), 'current':(status.creationD !== null && JobStatistics[index + 1].creationD == null && status.jobStatus !== 'Hired' && status.jobStatus !== 'Disqualified')}">
                            <img src="../assets/blue_applied.svg" class="statusImg" v-if="status.jobStatus === 'Applied' && status.creationD !== null && JobStatistics[index + 1].creationD == null">
                            <img src="../assets/green_applied.svg" class="statusImg" v-if="status.jobStatus === 'Applied' && status.creationD !== null && JobStatistics[index + 1].creationD !== null">
                            <img src="../assets/blue_review.svg" class="statusImg" v-if="status.jobStatus === 'Review' && status.creationD !== null && JobStatistics[index + 1].creationD == null" alt="review">
                            <img src="../assets/green_review.svg" class="statusImg" v-if="status.jobStatus === 'Review' && status.creationD !== null && JobStatistics[index + 1].creationD !== null" alt="review">
                            <img src="../assets/gray_review.svg" class="statusImg" v-if="status.jobStatus === 'Review' && status.creationD == null" alt="review">
                            <img src="../assets/blue_assessment.svg" class="statusImg" v-if="status.jobStatus === 'Assessment' && status.creationD !== null && JobStatistics[index + 1].creationD == null" alt="assessment">
                            <img src="../assets/green_assessment.svg" class="statusImg" v-if="status.jobStatus === 'Assessment' && status.creationD !== null && JobStatistics[index + 1].creationD !== null" alt="assessment">
                            <img src="../assets/gray_assessment.svg" class="statusImg" v-if="status.jobStatus === 'Assessment' && status.creationD == null" alt="assessment">
                            <img src="../assets/blue_shortlisted.svg" class="statusImg" v-if="status.jobStatus === 'Shortlisted' && status.creationD !== null && JobStatistics[index + 1].creationD == null" alt="shortlisted">
                            <img src="../assets/green_shortlisted.svg" class="statusImg" v-if="status.jobStatus === 'Shortlisted' && status.creationD !== null && JobStatistics[index + 1].creationD !== null" alt="shortlisted">
                            <img src="../assets/gray_shortlisted.svg" class="statusImg" v-if="status.jobStatus === 'Shortlisted' && status.creationD == null" alt="shortlisted">
                            <img src="../assets/blue_interview.svg" class="statusImg" v-if="status.jobStatus === 'Interview' && status.creationD !== null && JobStatistics[index + 1].creationD == null" alt="interview">
                            <img src="../assets/green_interview.svg" class="statusImg" v-if="status.jobStatus === 'Interview' && status.creationD !== null && JobStatistics[index + 1].creationD !== null" alt="interview">
                            <img src="../assets/gray_interview.svg" class="statusImg" v-if="status.jobStatus === 'Interview' && status.creationD == null" alt="interview">
                            <img src="../assets/blue_selected.svg" class="statusImg" v-if="status.jobStatus === 'Selected' && status.creationD !== null && JobStatistics[index + 1].creationD == null" alt="selected">
                            <img src="../assets/green_selected.svg" class="statusImg" v-if="status.jobStatus === 'Selected' && status.creationD !== null && JobStatistics[index + 1].creationD !== null" alt="selected">
                            <img src="../assets/gray_selected.svg" class="statusImg" v-if="status.jobStatus === 'Selected' && status.creationD == null" alt="selected">
                            <img src="../assets/green_hired.svg" class="statusImg" v-if="status.jobStatus === 'Hired' && status.creationD !== null" alt="hired">
                            <img src="../assets/gray_hired.svg" class="statusImg" v-if="status.jobStatus === 'Hired' && status.creationD == null" alt="hired">
                            <img src="../assets/JobDisqualified.svg" class="disqstatusImg disqtext" v-if="status.jobStatus === 'Disqualified' && status.creationD !== null" alt="disqualified">
                            <div class="d-flex ml-3 ml-md-5 pb-3 pl-2 pt-1" v-if="status.jobStatus !== 'Disqualified'">
                              <div class="d-flex flex-column mt-0 text-capitalize p-0 ">
                                <span class="proximanova-semibold fontsize16 black pl-2 notdisq" v-if="status.jobStatus">{{status.jobStatus}}</span>
                                <div class="d-flex pl-2 mt-1 mb-2">
                                  <!-- <div class="d-flex flex-column mr-3" v-if="status.jobStatus === 'Review'">
                                    <span class="proximanova fontsize12 black60">Applied</span>
                                    <span class="proximanova-semibold fontsize12 black80" v-if="JobCreationDate">{{ JobCreationDate | moment("DD/MM/YYYY") }}</span>
                                    <span class="proximanova-semibold fontsize12 black80" v-else>{{ selectedtrackJobDetails.creationD | moment("DD/MM/YYYY") }}</span>
                                  </div> -->
                                  <div class="d-flex flex-column">
                                    <!-- <span class="proximanova fontsize12 black60">{{status.jobStatus}}</span> -->
                                    <!-- <span class="proximanova fontsize12 black60" v-if="status.jobStatus === 'Review'">Review</span> -->
                                    <!-- <span class="proximanova fontsize12 black60" v-if="status.jobStatus !== 'Review'">Date</span> -->
                                    <span class="proximanova fontsize12 black60">Date</span>
                                    <span class="proximanova-semibold fontsize12 black80" v-if="status.creationD">{{ status.creationD | moment("DD/MM/YYYY") }}</span>
                                    <span class="proximanova-semibold fontsize12 black80" v-else>Not Scheduled</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex ml-3 ml-md-5 pb-3 pl-2 pt-1" v-if="status.jobStatus == 'Disqualified' && status.creationD !== null">
                              <div class="d-flex flex-column mt-0 text-capitalize p-0 ">
                                <span class="proximanova-semibold fontsize16 black pl-2 disqtext" v-if="status.jobStatus">{{status.jobStatus}}</span>
                                <div class="d-flex pl-2 mt-1 mb-2">
                                  <div class="d-flex flex-column">
                                    <span class="proximanova fontsize12 black60">Date</span>
                                    <span class="proximanova-semibold fontsize12 black80" v-if="status.creationD">{{ status.creationD | moment("DD/MM/YYYY") }}</span>
                                    <span class="proximanova-semibold fontsize12 black80" v-else>Not Scheduled</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </span>
                      </ul>
                    </div>
                </div>                   
              </div>  
            </div>
          </div>
        </div>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
          <pendingActivities />
        </div>
        <view-job-modal v-if="viewJobModal" :JobObject="JobObject" @closeJobDetailsModal="closeJobDetailsModal"></view-job-modal>
      </div>
    </div>
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import httppostjob from "@/js/http-postjob.js"
import pendingActivities from "../components/PendingActivities.vue";
import viewJobModal from "../components/ViewJobDetailsModal.vue"
import { bus } from "../main";
import sessionUtils from '@/js/session-util.js'
import $ from "jquery";
export default {
    components: {
        pendingActivities,
        viewJobModal
    },
    props : [
        // 'selectedtrackJobDetails'
    ],
    data(){
        return{
            pageloader : true,
            viewJobModal : false,
            jobaliasId : null,
            loginUserProfileId : null,
            selectedtrackJobDetails : null,
            JobObject : null,
            JobStatistics : null,
            JobCreationDate : null,
            jobNotFound : false,
        }
    },
    watch: {
    '$route.params.id': function (id) {     
      this.jobaliasId = id; 
      this.jobNotFound = false;
      this.pageloader = true;
      this.getSelectedJobTrackDetails()
    },    
        },
    mounted(){
      this.jobaliasId = this.$route.params.id;
      this.loginUserProfileId = sessionUtils.getUserProfileId()
      this.getSelectedJobTrackDetails()
    },
    methods:{
      getSelectedJobTrackDetails() {
        console.log("selected track id : ", this.jobaliasId, this.loginUserProfileId)
        httppostjob.get('/postjob/getJobResponseForTracking?aliasId='+this.jobaliasId+'&profileId='+this.loginUserProfileId)
        .then((response) => {
          this.pageloader = false
          console.log("selected job tracking details : ", response.data)
          if(response.data && response.data.errorCode && response.data.errorCode == 1021){
            this.jobNotFound = true;
          }else{
            this.jobNotFound = false;
            this.selectedtrackJobDetails = response.data;
            this.JobStatistics = this.selectedtrackJobDetails.empJobApplicantStatus;
            this.setAppliedDate();
          }
        }).catch((e) => {
          console.log(e)
          this.pageloader = false;
        })
        
      },
        setAppliedDate(){
          for(var i =0; i < this.JobStatistics.length; i++){
            if(this.JobStatistics[i].jobStatus == 'Applied' && this.JobStatistics[i].creationD !== null){
              this.JobCreationDate = this.JobStatistics[i].creationD;
            }
          }
        },
        closeJobDetailsModal() {
            this.viewJobModal = false;
        },
        previous(){
            this.$router.go(-1);
            // bus.$emit('gotoTrackApplicationsList', false);
        },
        // this will invoke after click on view job details
        // this will open a modal component where user can able to see all the selected job information
        viewJobDetails() {
            console.log(this.selectedtrackJobDetails)
            this.JobObject = this.selectedtrackJobDetails;
            this.viewJobModal = true;
        }
    },
    created(){
        
    }, 
    destroyed() {
        
    }
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.statusImg{
    vertical-align: baseline;
    width: 40px;
    height: 40px;
    z-index: 3;
    background: white;
    cursor: pointer;
}
.disqstatusImg {
    width: 31px;
    height: 31px;
    margin-left: 6px;
}
.done{
  background-color: green;
}
.inprogress{
   background-color: blue;
}
.notstarted{
   background-color: grey;
}
.prof-img{
  width: 50px;
  height: 50px
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
} 
/* progressbar styles */

.democlass{
  display: flex;
  flex-direction: column;
}
.StepProgress {
  position: relative;
  /* padding-left: 45px; */
  list-style: none;
}
.StepProgress::before {
  display: inline-block;
  content: '';
  position: absolute;
  top: 0;
  /* left: 46px; */
  width: 10px;
  height: 100%;
    margin-left: 20px;
    border-left: 2px solid #CCC;
}
  
  .StepProgress-item {
    display: flex;
    position: relative;
    counter-increment: list;
  }
  .StepProgress-item:not(:last-child) {
      padding-bottom: 20px;
    }
    
    .StepProgress-item::before {
      display: inline-block;
      content: '';
      position: absolute;
      left: -30px;
      height: 100%;
      width: 10px;
    }
    
    .StepProgress-item::after {
      /* content: url("../assets/NoStatus.svg"); */
      /* content: 'x';
      display: inline-block; */
      position: absolute;
      top: 0;
      left: -37px;
      width: 30px;
      margin-left: 10px;
        height: 30px;
        color: #CCC;
        text-align: center;
      border: 2px solid #CCC;
      border-radius: 50%;
      background-color: #FFF;
    }
    
        .is-done::before {
        border-left: 2px solid#1EC6A0;
        margin-left: 50px;
      }
      .is-done::after {
        /* content: "✔";
        font-size: 10px;
        width: 30px;
        margin-left: 10px;
        padding-top: 8px;
        height: 30px; */
        color: #FFF;
        text-align: center;
        border: 2px solid #1EC6A0;
        background-color: #1EC6A0;
      }
      .is-done1::before {
        border-left: 2px solid#1EC6A0;
        margin-left: 50px;
      }
      .is-done1::after {
        color: #FFF;
        text-align: center;
        border: 2px solid #1EC6A0;
        background-color: #1EC6A0;
      }
        .current::before {
        border-left: 2px solid #007AFF;
        margin-left: 50px;
      }
      
      .current::after {
        /* content: '+';
        padding-top: 4px;
        width: 30px;
        height: 30px;
        top: -4px;
        margin-left: 10px; */
        /* left: -40px; */
        font-size: 14px;
        text-align: center;
        color: #007AFF;
        border: 2px solid #007AFF;
        background-color: white;
      }
  
  strong {
    display: block;
  }
@media only screen and (max-width: 600px) {
  .fontsize24{
    font-size: 16px
  }
   .prof-img {
    width: 36px;
    height: 36px;
}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
@media screen and (min-width: 550px) and (max-width : 768px){
    .pageloader {
        width: 12%;
        margin-top: 25%;
        margin-left: 46%;
    } 
}
@media screen and (max-width : 550px) {
    .pageloader {
        width: 15%;
        margin-top: 25%;
        margin-left: 42%;
    } 
}
</style>